import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components';

const Checkbox = ({ checked = false, onChange }) => {
    return (
        <StyledWrapper >
            <label className="container">
                <input type="checkbox" checked={checked} onChange={onChange} />
                <svg className="chevron-right" xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 320 512"><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z" /></svg>
                <svg className="chevron-down" xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512"><path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z" /></svg>
            </label>
        </StyledWrapper>
    );
}

const StyledWrapper = styled.div`
  /*------ Settings ------*/
  .container {
    --color: #a5a5b0;
    --size: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    cursor: pointer;
    font-size: var(--size);
    user-select: none;
    fill: var(--color);
    margin: 15px;
  }

  .container .chevron-right {
    position: absolute;
    animation: keyframes-return .5s;
  }

  .container .chevron-down {
    position: absolute;
    display: none;
    animation: keyframes-fill .5s;
  }

  /* ------ On check event ------ */
  .container input:checked ~ .chevron-right {
    display: none;
  }

  .container input:checked ~ .chevron-down {
    display: block;
  }

  /* ------ Hide the default checkbox ------ */
  .container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  /* ------ Animation ------ */
  @keyframes keyframes-fill {
    0% {
      transform: rotate(-90deg) scale(0);
      opacity: 0;
    }

    50% {
      transform: rotate(0deg) scale(1.2);
    }
  }

  @keyframes keyframes-return {
    0% {
      transform: rotate(90deg) scale(0);
      opacity: 0;
    }

    50% {
      transform: rotate(0deg) scale(1.2);
    }
  }`;


const LocalBox = styled.div`
width: 100%;
    .dropInputMainbox{
    
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    transition: 0.3s ease-in-out;
    border-radius: 10px;
    gap: 5px;
    }
    .dropInputMainbox.down{
        background-color: #f0f0f0;
        padding: 5px;
    }
    .dropInputTopbox{
    width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: stretch;
        gap: 2px;
    }
        
`
const Label = styled.label`
  display: block;
  margin-bottom: 5px;
  font-weight: 500;
  text-align: left;
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
`;
const Input = styled.input`
  width: 100%;
  padding: 8px 0;
  border-radius: 5px;
  border: 1px solid #ccc;
  text-indent: 8px;
`;
export const DropInput = ({ nazwa = "Tytuł inputa", type = "text", value, onChange }) => {
    const [chosen, setChosen] = useState(false)
    return (
        <LocalBox>
            <div className={chosen ? 'dropInputMainbox down' : 'dropInputMainbox'}>
                <div className='dropInputTopbox'>
                    <Label>{nazwa}<span style={{fontSize: '12px', marginLeft: '3px'}}>(opcjonalne)</span></Label>
                    <Checkbox checked={chosen} onChange={() => setChosen(!chosen)} />

                </div>
                {chosen ? <Input type={type} value={value} onChange={onChange} /> : ""}
            </div>
        </LocalBox>


    )
}